/* eslint-disable @typescript-eslint/no-floating-promises */
import { setLoadingStatus } from './LoadingStatus';
import { postJSON } from './Fetch';
import DataStore from './DataStore';
import { client as apolloClient } from '../api/client';
import { showError } from '../components/App/AppAlert';
import { queryClient } from '../api/QueryProvider';

type Options = {
  onSuccess: () => void;
};

const dataStore = DataStore.getInstance('app');

export function loginAsAccount(accountId: string, options: Options) {
  setLoadingStatus(true);
  postJSON('/api/auth_id', { account_id: accountId }, (error, data) => {
    if (error) {
      showError(error.message);
      return;
    }
    if (data && data.success) {
      let user = dataStore.get('user');
      dataStore.clearAll();
      queryClient.clear();
      apolloClient.resetStore();
      dataStore.set('user', user);
      dataStore.set('account', {
        ...data.account,
        token: data.token,
        system_admin: true,
      });
      setLoadingStatus(false);
      options.onSuccess();
    }
  });
}
